import React from 'react';
import { Button } from 'semantic-ui-react';
import { AppointmentMeHey } from './AppointmentMeHeyUtils';
import { getAppointmentStatusInfo } from './CardMakeAppointmentMeHey';

interface AppointmentRightPanelMeHeyProps {
  selectedDoctorDSB: (AppointmentMeHey & { dsb?: any }) | null;
  panelBackgroundColor: string;
  sortField: 'time' | 'status' | null;
  sortDirection: 'asc' | 'desc';
  onSort: (field: 'time' | 'status') => void;
  runSequence: any;
}

const AppointmentRightPanelMeHey: React.FC<AppointmentRightPanelMeHeyProps> = (props) => {

  const getSortedAppointments = () => {
    if (!props.selectedDoctorDSB?.dsb?.appointments) return [];

    let sortedAppointments = [...props.selectedDoctorDSB.dsb.appointments];

    if (props.sortField === 'time') {
      sortedAppointments.sort((a, b) => {
        const timeA = new Date(a.estimated_at).getTime();
        const timeB = new Date(b.estimated_at).getTime();
        return props.sortDirection === 'asc' ? timeA - timeB : timeB - timeA;
      });
    } else if (props.sortField === 'status') {
      sortedAppointments.sort((a, b) => {
        return props.sortDirection === 'asc' ? a.status - b.status : b.status - a.status;
      });
    }

    return sortedAppointments;
  };

  const handleCreateClick = () => {
    props.runSequence({
      sequence: "MakeAppointmentMeHey",
      action: "SET_SHOW_CREATE_MODAL",
      showCreateModal: true,
    });
  };

  const handlePanelAppointmentClick = (appointment: any) => {
    props.runSequence({
      sequence: "MakeAppointmentMeHey",
      action: "SET_SHOW_EDIT_MODAL",
      appointmentId: appointment.id,
      showCreateModal: true,
    });
  };

  const handleChatClick = (hn: string) => {
    props.runSequence({
      sequence: "MakeAppointmentMeHey",
      action: "OPEN_CHAT_WINDOW",
      patientHN: hn,
    });
  };

  return (
    <div className="appointment-panel">
      <div className="panel-header">
        {props.selectedDoctorDSB && props.selectedDoctorDSB.dsb ? (
          <div className="panel-selected-appointment-header">
            {(() => {
              const startTime = props.selectedDoctorDSB.startTime;
              const endTime = props.selectedDoctorDSB.endTime;
              const dateStr = `${startTime.getDate().toString().padStart(2, '0')}/${(startTime.getMonth() + 1).toString().padStart(2, '0')}/${startTime.getFullYear()}`;
              const startTimeStr = `${startTime.getHours()}:${startTime.getMinutes().toString().padStart(2, '0')}`;
              const endTimeStr = `${endTime.getHours()}.${endTime.getMinutes().toString().padStart(2, '0')}`;

              return `${dateStr} [${startTimeStr} - ${endTimeStr}] ${props.selectedDoctorDSB.title}`;
            })()}
          </div>
        ) : (
          <h3 className="panel-instruction-text">หากต้องการตรวจสอบนัดหมายของผู้ให้บริการ คลิกเลือกช่วงเวลาที่ต้องการ</h3>
        )}

        <Button
          color="pink"
          size="small"
          onClick={handleCreateClick}
          disabled={!props.selectedDoctorDSB}
        >
          + สร้างนัดหมาย
        </Button>
      </div>

      <div
        className="panel-content"
        style={props.panelBackgroundColor ? { backgroundColor: props.panelBackgroundColor } : {}}
      >
        {/* Table Header */}
        <div className="panel-table-header">
          <div style={{ justifyContent: "flex-start" }}>ผู้รับบริการ</div>
          <div>แชท</div>
          <div
            className="sortable-header"
            onClick={() => props.onSort('time')}
            style={{ cursor: 'pointer' }}
          >
            เวลานัด
            {props.sortField === 'time' && (
              <span style={{ marginLeft: '4px' }}>
                {props.sortDirection === 'asc' ? '↑' : '↓'}
              </span>
            )}
          </div>
          <div
            className="sortable-header"
            onClick={() => props.onSort('status')}
            style={{ cursor: 'pointer' }}
          >
            สถานะนัดหมาย
            {props.sortField === 'status' && (
              <span style={{ marginLeft: '4px' }}>
                {props.sortDirection === 'asc' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </div>

        {props.selectedDoctorDSB && props.selectedDoctorDSB.dsb && props.selectedDoctorDSB.dsb.appointments && props.selectedDoctorDSB.dsb.appointments.length > 0 ? (
          <div className="panel-appointments-list">
            {getSortedAppointments().map((apt: any) => {
              const estimatedTime = new Date(apt.estimated_at);
              const timeString = `${estimatedTime.getHours().toString().padStart(2, '0')}:${estimatedTime.getMinutes().toString().padStart(2, '0')}`;

              const statusInfo = getAppointmentStatusInfo(apt.status);
              const statusText = statusInfo.text;
              const statusClass = statusInfo.className;

              return (
                <div
                  key={apt.id}
                  className="panel-appointment-row"
                  onClick={() => handlePanelAppointmentClick(apt)}
                >
                  <div className="panel-appointment-name">
                    {apt.first_name} {apt.last_name}
                  </div>
                  <div className="panel-appointment-chat" onClick={(e) => {
                    e.stopPropagation();
                    handleChatClick(apt.hn);
                  }}>
                    <img height="16px" width="16px" src="/static/images/schedule/chat-grey-icon.png" alt="chat" />
                  </div>
                  <div className="panel-appointment-time">{timeString}</div>
                  <div className="panel-appointment-status">
                    <span className={`appointment-status-badge ${statusClass}`}>
                      {statusText}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="panel-empty-state">
            <p>คลิกที่นัดหมายในปฏิทินเพื่อดูรายการนัดหมาย</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppointmentRightPanelMeHey;